class HeaderMobileSearch extends HTMLElement {
  #controller;
  #button;
  #viewport = matchMedia('(max-width: 1400px)');

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#button = document.getElementById(this.dataset.toggleId);
    if (!this.#button) return;

    this.#button.addEventListener('click', () => {
      this.#setOpen(!this.hasAttribute('data-open'), true);
    }, { signal });

    this.closest('.header-section')?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('data-open')) {
        event.preventDefault();
        this.#setOpen(false, true);
      }
    }, { signal });

    // Closing when the burger opens keeps the two search interfaces independent.
    this.closest('.header-section')?.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement &&
          event.target.id === 'Details-menu-drawer-container' && event.target.open) {
        this.#setOpen(false);
      }
    }, { capture: true, signal });

    this.#viewport.addEventListener('change', () => this.#setOpen(false), { signal });
    this.#setOpen(false);
  }

  #setOpen(open, focus = false) {
    open = open && this.#viewport.matches;
    this.toggleAttribute('data-open', open);
    this.inert = !open;
    this.setAttribute('aria-hidden', String(!open));
    this.#button?.setAttribute('aria-expanded', String(open));
    this.#button?.setAttribute('aria-label', open
      ? this.#button.dataset.closeLabel : this.#button.dataset.searchLabel);

    if (focus) {
      if (open) this.querySelector('input[type="search"]')?.focus({ preventScroll: true });
      else this.#button?.focus({ preventScroll: true });
    } else if (!open && this.contains(document.activeElement)) {
      document.activeElement?.blur();
    }
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('header-mobile-search')) {
  customElements.define('header-mobile-search', HeaderMobileSearch);
}
